'use strict';

var memo = require('./memo.cjs');

const supportsLinearEasing = /*@__PURE__*/ memo.memoSupports(() => {
    try {
        document
            .createElement("div")
            .animate({ opacity: 0 }, { easing: "linear(0, 1)" });
    }
    catch (e) {
        return false;
    }
    return true;
}, "linearEasing");

exports.supportsLinearEasing = supportsLinearEasing;
//# sourceMappingURL=linear-easing.cjs.map
